import { useEffect, useState } from 'react';

export default function BackTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg shadow-primary-500/30 transition hover:bg-primary-600 md:bottom-8 md:right-8"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}